import PropTypes from "prop-types"
import React from "react"
import {Link} from "gatsby"

const Header = ({ siteTitle }) => {

  return (
    <header className="h-16">
      <div className="p-3 text-2xl">
        <Link to='/' className="no-underline">
          <h1 className="font-serif text-4xl">{siteTitle}</h1>
        </Link>
      </div>
    </header>
  );
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
